import React from 'react'

export function BOB() {
	return (
		<main role="main">
			<div id="loginWidgetContainer" />
		</main>
	)
}
